// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2YU50","row":"ProcedureTreatmentSummary_row__3Y8bd"};